export const vkConstants = {
    USER_INFO: 'VKWebAppGetUserInfoResult',
    PHONE_NUMBER: 'VKWebAppGetPhoneNumberResult',
};
